/* SLIDE 7 */
/* SLIDE 9 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSpot, fetchAllParkingSpots } from "features/parking/presentation/store/parkingSlice";
import SubHeader from "../../../shared/components/SubHeader";
import SkeletonLoader from "shared/components/Skeleton";
const ParkingSetting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { parkingSpots, selectedSpot, parkingName, loading } = useSelector((state) => state.parking);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchAllParkingSpots({parkingId: user.parkingId, page: 'parkingSetting'}));
  }, [dispatch]);

  const handleSpotClick = (spot) => {
    dispatch(setSelectedSpot(spot));
    navigate("/parking_spot_setting", {state: { spaceNumber: spot.spaceNumber }});
  };

  return (
    loading?.parkingSpots ? <SkeletonLoader /> : <div className={`parking-status-container`}>
      <div className="setting-mode">
        <SubHeader className={"htFixed"}>
          <div className="nl-row f-column">
            <span className="htBold">주차면 설정</span>
            <div className={`sub-header-text w-full`}>
              <span className="htColorGray2">주차장명 : </span>
              {user?.parking?.parkingName && (
                <span className="htBold">
                  {user?.parking?.parkingName} ({user.parkingId})
                </span>
              )}
            </div>
          </div>

        </SubHeader>
        <div className="pt-80">
          <p className="text-description">
            주차면을 선택하여 주차면을 세부설정합니다
          </p>
        </div>
        <div className="parking-grid pg-setting">
          {parkingSpots?.map((spot) => (
            <div
              key={spot.spaceNumber}
              className="parking-slot"
              onClick={() => handleSpotClick(spot)}
            >
              <div className="slot-number">{spot.spaceNumber}</div>
              <div className="slot-status slot-parking">
                <div className="nh-slot">
                  {spot.areaName}
                </div>
                <div className="nh-slot">
                  ({spot.areaTypeName})
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParkingSetting;
